/**
 * Formatter
 *
 * formatter.date(Object Date, String)
 * formatter.decodeHTML(Object)
 *
 * formatter.formatNumber(number)
 * formatter.formatNumber(number, { precision: 2, thSeparator: ' ', decSeparator: '.' })
 *
 * formatter.formatCurrency(amount)
 * formatter.formatCurrency(amount, { currencyCode: 'EUR', symbolAtTheLeft: true,
 *      precision: 2, thSeparator: ' ', decSeparator: '.' })
 *
 * [String]
 * http://pubs.opengroup.org/onlinepubs/007908799/xsh/strftime.html
 * + bonus: milliseconds as %SSS
 */
define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');

    var _numberDefaults = {
        precision: null,
        thSeparator: ',',
        decSeparator: '.'
    };
    var _currencyDefaults = {
        precision: 2,
        symbolAtTheLeft: true
    };

    var formatter = {

        numberOptions: _.clone(_numberDefaults),

        currencyOptions: _.clone(_currencyDefaults),

        currencies: {
            'ALL': 'Lek',
            'AFN': '&#1547;',
            'ARS': '$',
            'AWG': 'ƒ',
            'AUD': '$',
            'AZN': 'ман',
            'BSD': '$',
            'BBD': '$',
            'BYR': 'p.',
            'BZD': 'BZ$',
            'BMD': '$',
            'BOB': '$b',
            'BAM': 'KM',
            'BWP': 'P',
            'BGN': 'лв',
            'BRL': 'R$',
            'BND': '$',
            'KHR': 'R',
            'CAD': '$',
            'KYD': '$',
            'CLP': '$',
            'CNY': '\xA5',
            'COP': '$',
            'CRC': '\u20A1',
            'HRK': 'kn',
            'CUP': '\u20B1',
            'CZK': 'Kč',
            'DKK': 'kr',
            'DOP': 'RD$',
            'XCD': '$',
            'EGP': '\xA3',
            'SVC': '$',
            'EEK': 'kr',
            'EUR': '\u20AC',
            'FKP': '\xA3',
            'FJD': '$',
            'GHC': '\xA2',
            'GIP': '\xA3',
            'GTQ': 'Q',
            'GGP': '\xA3',
            'GYD': '$',
            'HNL': 'L',
            'HKD': '$',
            'HUF': 'Ft',
            'ISK': 'kr',
            'INR': '\u20B9',
            'IDR': 'Rp',
            'IRR': '\uFDFC',
            'IMP': '\xA3',
            'ILS': '\u20AA',
            'JMD': 'J$',
            'JPY': '\xA5',
            'JEP': '\xA3',
            'KZT': 'лв',
            'KPW': '\u20A9',
            'KRW': '\u20A9',
            'KGS': 'лв',
            'LAK': '\u20AD',
            'LVL': 'Ls',
            'LBP': '\xA3',
            'LRD': '$',
            'LTL': 'Lt',
            'MKD': 'ден',
            'MYR': 'RM',
            'MUR': '\u20A8',
            'MXN': '$',
            'MNT': '\u20AE',
            'MZN': 'MT',
            'NAD': '$',
            'NPR': '\u20A8',
            'ANG': 'ƒ',
            'NZD': '$',
            'NIO': 'C$',
            'NGN': '\u20A6',
            'NOK': 'kr',
            'OMR': '\uFDFC',
            'PKR': '\u20A8',
            'PAB': 'B/.',
            'PYG': 'Gs',
            'PEN': 'S/.',
            'PHP': '\u20B1',
            'PLN': 'zł',
            'QAR': '\uFDFC',
            'RON': 'lei',
            'RUB': 'руб',
            'SHP': '\xA3',
            'SAR': '\uFDFC',
            'RSD': 'Дин.',
            'SCR': '\u20A8',
            'SGD': '$',
            'SBD': '$',
            'SOS': 'S',
            'ZAR': 'R',
            'LKR': '\u20A8',
            'SEK': 'kr',
            'CHF': 'CHF',
            'SRD': '$',
            'SYP': '\xA3',
            'TWD': 'NT$',
            'THB': '\u0E3F',
            'TTD': 'TT$',
            'TRL': '\u20A4',
            'TVD': '$',
            'UAH': '\u20B4',
            'GBP': '\xA3',
            'USD': '$',
            'UYU': '$U',
            'UZS': 'лв',
            'VEF': 'Bs',
            'VND': '\u20AB',
            'YER': '\uFDFC',
            'ZWD': 'Z$'
        },

        dateFormats: {
            'default': {
                dateTimeLongMs: '%Y-%m-%d %H:%M:%S.%SSS',
                dateTimeLong: '%Y-%m-%d %H:%M:%S',
                dateTimeShort: '%Y-%m-%d %H:%M',
                date: '%Y-%m-%d',
                timeLong: '%H:%M:%S',
                timeShort: '%H:%M'
            },
            'italian': {
                dateTimeLongMs: '%d/%m/%Y %H:%M:%S.%SSS',
                dateTimeLong: '%d/%m/%Y %H:%M:%S',
                dateTimeShort: '%d/%m/%Y %H:%M',
                date: '%d/%m/%Y',
                timeLong: '%H:%M:%S',
                timeShort: '%H:%M'
            }
        },

        locales: {
            'en_US': {},
            'en_GB': {},
            'en_CA': {},
            'da_DK': {
                number: {
                    thSeparator: '.',
                    decSeparator: ','
                },
                currency: {
                    symbolAtTheLeft: false
                }
            },
            'sv_SE': {
                number: {
                    thSeparator: ' ',
                    decSeparator: ','
                },
                currency: {
                    symbolAtTheLeft: false
                }
            },
            'no_NO': {},
            'en_AU': {},
            'es_MX': {},
            'de_CH': {
                number: {
                    thSeparator: '\'',
                    decSeparator: '.'
                }
            },
            'fr_CH': {
                number: {
                    thSeparator: ' ',
                    decSeparator: '.'
                }
            },
            'it_CH': {
                number: {
                    thSeparator: ' .',
                    decSeparator: ','
                },
                currency: {
                    symbolAtTheLeft: false
                }
            },
            'en_ZA': {
                number: {
                    thSeparator: ' ',
                    decSeparator: ','
                }
            }
        },

        regulations: {
            'italian': {
                number: {
                    thSeparator: ' ',
                    decSeparator: ','
                }
            }
        },

        /**
         * Accept source object for converting
         * @param  {Date|String|Number} obj
         * @param  {String}             str
         * @param  {String=}            locale
         * @return {String}
         */
        date: function(obj, str, locale) {
            // Fix time string for some JS engines and convert it to a Date

            if (!obj) {
                obj = new Date();
            }

            /**
             * bad time string format  "2014-08-22T12:06:30+0200" (for iOS with spaces)
             * good time string format "2014-08-19T18:59:21+02:00"
             */
            if (typeof obj === 'string' && /([-+])\d{4}$/.test(obj)) {
                obj = new Date(obj.slice(0, obj.length - 2) + ':' + obj.slice(obj.length - 2));
            }
            /**
             * bad time string format "2014-08-22 12:06:30.0200" (for iOS with spaces)
             * good time string format "2014-08-22T12:06:30.0200"
             */
            else if (typeof obj === 'string' && / /.test(obj)) {
                obj = new Date(obj.replace(' ', 'T'));
            } else if (!(obj instanceof Date)) {
                obj = new Date(obj);
            }

            /**
             * Convert Date to a String
             * @private
             * @param  {String} dateStr
             * @return {String}
             */
            var _formatDate = function(dateStr) {

                if (typeof dateStr !== 'string') {
                    dateStr = String(dateStr);
                }

                return dateStr.replace(/%%|%(SSS|[abcCdDeEHIjmMprRSTxXyYzZ])/g, function(match, code) {
                    if (match === '%%') {
                        return '%';
                    }
                    return _formatDate[code](obj);
                });
            };
            /**
             * Pad a number with leading zeros
             * @private
             * @param  {Number} n
             * @param  {String} placer
             * @param  {Number} len
             * @return {String}
             */
            _formatDate._padZero = function(n, placer, len) {
                if (typeof placer === 'undefined') {
                    placer = '0';
                }
                if (typeof len === 'undefined') {
                    len = 2;
                }
                n = placer + n.toString();
                return n.substr(-len);
            };

            _formatDate.a = function(date) {
                return date.toDateString().split(' ')[0];
            };

            _formatDate.b = function(date) {
                return date.toDateString().split(' ')[1];
            };

            _formatDate.C = function(date) {
                return date.getFullYear().toString().substr(0, 2);
            };

            _formatDate.c = function(date) {
                return date.toLocaleString();
            };

            _formatDate.D = function() {
                return _formatDate('%m/%d/%y');
            };

            _formatDate.d = function(date) {
                return _formatDate._padZero(date.getDate());
            };

            _formatDate.e = function(date) {
                return _formatDate._padZero(date.getMonth() + 1, ' ');
            };

            _formatDate.E = function(date) {
                var sufix,
                    value,
                    day = date.getMonth() + 1;

                switch (locale) {
                    case 'en_US':
                        sufix = ['th', 'st', 'nd', 'rd'];
                        value = day % 100;
                        day += sufix[(value - 20) % 10] || sufix[value] || sufix[0];
                        break;
                    case 'ru_RU':
                        day += '-e';
                        break;
                    case 'da_DK':
                    case 'sv_SE':
                        day += ':e';
                        break;
                    case 'de_DE':
                        day += '.';
                        break;
                    case 'nl_NL':
                    case 'fr_FR':
                        day += 'e';
                        break;
                    case 'ro_RO':
                        day += 'a';
                        break;
                    default:
                        day = String(day);
                        break;
                }
                return day;
            };

            _formatDate.H = function(date) {
                return _formatDate._padZero(date.getHours());
            };

            _formatDate.I = function(date) {
                return _formatDate._padZero(date.getHours() % 12);
            };

            _formatDate.j = function(date) {
                var day = 0,
                    i = 0,
                    len = date.getMonth();
                for (; i < len; i++) {
                    day += 30;
                }
                return _formatDate._padZero(day + date.getDate(), '0', 3);
            };

            _formatDate.m = function(date) {
                return _formatDate._padZero(date.getMonth() + 1);
            };

            _formatDate.M = function(date) {
                return _formatDate._padZero(date.getMinutes());
            };

            _formatDate.p = function(date) {
                return ['AM', 'PM'][Math.floor(date.getHours() / 12)];
            };

            _formatDate.r = function() {
                return _formatDate('%I:%M:%S %p');
            };

            _formatDate.R = function() {
                return _formatDate('%H:%M');
            };

            _formatDate.S = function(date) {
                return _formatDate._padZero(date.getSeconds());
            };

            _formatDate.SSS = function(date) {
                var ms = date.getMilliseconds().toString();
                while (ms.length < 3) {
                    ms = ms.concat('0');
                }
                return ms;
            };

            _formatDate.T = function() {
                return _formatDate('%H:%M:%S');
            };

            _formatDate.x = function(date) {
                return date.toLocaleDateString();
            };

            _formatDate.X = function(date) {
                return date.toLocaleTimeString();
            };

            _formatDate.y = function(date) {
                return date.getFullYear().toString().substr(2);
            };

            _formatDate.Y = Date.prototype.getFullYear.bind(obj);

            _formatDate.Z = function(date) {
                var timeZone = date.getTimezoneOffset();

                return (timeZone > 0 ? '+' : '-') + _formatDate._padZero(Math.abs(timeZone), '0', 4);
            };

            if (Object.prototype.toString.call(obj) === '[object Date]') {
                this.type = 'Date';
                /**
                 * Date formatter
                 * @param  {String} str
                 * @return {String}
                 */
                return this.format = _formatDate(str);
            }
        },

        /**
         * Detect date format
         * @return {String}
         */
        getDateFormat: function(type) {
            var regulation = Playtech.Variables.regulation;

            var format = formatter.dateFormats[regulation] || formatter.dateFormats.default;
            return format[type];
        },

        //region Locale independent date parsers & formatters

        /**
         * Parse date string received from IMS
         * IMS sends us date in non-standard format ('YYYY-MM-DD HH:MM:SS.sss') without specifying time zone,
         * but according to IMS documentation, this time always comes in GMT.
         * @param {String} date - unformatted Date
         * @returns {Date} parsed Date
         */
        parseImsDate: function(date) {
            return new Date(date.trim().replace(' ', 'T') + 'Z');
        },

        /**
         * Parse date string received from getUrlRequest
         * IMS sends us date in non-standard format ('YYYY-MM-DD+HH%3AMM%3ASS.sss') without specifying time zone,
         * but according to IMS documentation, this time always comes in GMT.
         * @param {String} date - unformatted Date
         * @returns {Date} parsed Date
         */
        parseImsBankIdDate: function(date) {
            var decodedDate = decodeURIComponent(date).replace('+', ' ');

            return formatter.parseImsDate(decodedDate);
        },

        /**
         * Get date in format to be sent to IMS (through OGW)
         * 'YYYY-MM-DD HH:MM:SS.sss' in GMT
         * @param {Date} date
         * @return {String}
         */
        getDateForIms: function(date) {
            return date.toISOString().replace(/[TZ]/g, ' ').trim();
        },

        /**
         * Formats date and time for export to CSV.
         * 'YYYY-MM-DD HH:MM' in local TZ
         * @param {Date|String} date
         * @returns {String}
         */
        getDateTimeForCsv: function(date) {
            return formatter.date(date, '%Y-%m-%d %H:%M');
        },

        /**
         * Formats date for export to CSV. Useful for file names.
         * 'YYYY-MM-DD' in local TZ
         * @param {Date|String} date
         * @returns {String}
         */
        getDateForCsv: function(date) {
            return formatter.date(date, '%Y-%m-%d');
        },

        //endregion

        /**
         * YYYY-MM-DD HH:MM:SS.sss
         * @param date
         */
        getDateTimeLongMs: function(date) {
            return formatter.date(date, formatter.getDateFormat('dateTimeLongMs'));
        },

        /**
         * YYYY-MM-DD HH:MM:SS
         * @param date
         */
        getDateTimeLong: function(date) {
            return formatter.date(date, formatter.getDateFormat('dateTimeLong'));
        },

        /**
         * YYYY-MM-DD HH:MM
         * @param date
         */
        getDateTimeShort: function(date) {
            return formatter.date(date, formatter.getDateFormat('dateTimeShort'));
        },

        /**
         * YYYY-MM-DD
         * @param date
         */
        getDate: function(date) {
            return formatter.date(date, formatter.getDateFormat('date'));
        },

        /**
         * HH:MM:SS
         * @param date
         */
        getTimeLong: function(date) {
            return formatter.date(date, formatter.getDateFormat('timeLong'));
        },

        /**
         * HH:MM
         * @param date
         */
        getTimeShort: function(date) {
            return formatter.date(date, formatter.getDateFormat('timeShort'));
        },

        /**
         * Fix incorrect ISO date parse (2017-04-28T12:15:03+0200 to 2017-04-28T12:15:03+02:00)
         * on some devices return 'Invalid date'
         * @param dateStr
         * @returns {Date|Window.Date}
         */
        getCorrectISODate: function(dateStr) {
            var date = new Date(dateStr);

            if (isNaN(date)) {
                var reg = /([+-]\d{2})(\d{2})$/;

                if (reg.test(dateStr)) {
                    dateStr = dateStr.replace(reg, '$1:$2');
                    date = new Date(dateStr);
                }
            }

            return date;
        },

        /**
         *  Formats amount to the decimals in low value
         *  @param amount
         *  @returns {string}
         */
        roundToDecimal: function(amount) {
            var concatAmount;
            if (isNaN(amount)) {
                return '';
            }
            concatAmount = amount.toString();
            concatAmount = concatAmount.split('.');
            if (concatAmount.length > 1) {
                concatAmount[1] = concatAmount[1].substr(0, 2);
            }
            return concatAmount.join('.');
        },

        /**
         * Converts seconds to HH:MM:SS or MM:SS
         * @param seconds
         */
        formatTimeFromSeconds: function(seconds) {
            var numberOfSeconds = parseInt(seconds),
                hoursOut,
                minutesOut,
                secondsOut;

            hoursOut = Math.floor(numberOfSeconds / 3600);
            minutesOut = Math.floor((numberOfSeconds - hoursOut * 3600) / 60);
            secondsOut = numberOfSeconds - hoursOut * 3600 - minutesOut * 60;

            if (hoursOut < 10) {
                hoursOut = '0' + hoursOut;
            }
            if (minutesOut < 10) {
                minutesOut = '0' + minutesOut;
            }
            if (secondsOut < 10) {
                secondsOut = '0' + secondsOut;
            }

            return hoursOut !== '00'
                ? hoursOut + ':' + minutesOut + ':' + secondsOut
                : minutesOut + ':' + secondsOut;
        },

        /**
         * Decode HTML characters in the string
         * @public
         * @param {String} html
         * @return {String}
         */
        decodeHTML: function(html) {
            // todo rename method to smth 'extract text from HTML' or 'html2text'
            var element = document.createElement('div');
            element.innerHTML = html;

            return element.innerText || element.textContent;
        },

        /**
         * @deprecated Use formatNumber() instead
         * Convert number to a String by some fomat
         * @param  {String} formatStr String for formating ' ' or for float ' .'
         * @param  {Number} num       Number for formating
         * @return {String}           String number with formating
         */
        number: function(formatStr, num) {
            if (typeof formatStr !== 'string') {
                formatStr = String(formatStr);
            }

            if (formatStr[formatStr.length - 1] === '.') {
                num = num.toFixed(2);
                formatStr = formatStr.substring(0, formatStr.length - 1);
            }

            return num.toString().replace(/(\d)(?=(\d{3})+\b)/g, '$1' + formatStr);
        },

        /**
         * @deprecated Use formatCurrency() instead
         * Accept source object for converting
         * @param  {Number|String} amount
         * @param  {String} currency
         * @param  {String} [locale]
         * @param  {Boolean} [floor]
         * @return {String}
         */
        currency: function(amount, currency, locale, floor) {
            var options = locale ? formatter.getOptionsFromLocale(locale) : {};

            if (currency) {
                options.currency = currency;
            }

            options.precision = floor ? 0 : 2;

            return formatter.formatCurrency(amount, options);
        },

        /**
         * @deprecated Use delocalizeNumber() instead.
         * Convert string to number if it's possible
         * @param {String} str - string to convert
         * @param {Object} [options] - format params
         * @param {String} [options.thSeparator] - thousand separator
         * @param {String} [options.decSeparator] - decimal separator
         * @return {Number|String}
         */
        convertToNumber: function(str, options) { // eslint-disable-line no-unused-vars
            return formatter.delocalizeNumber.apply(this, arguments);
        },

        /**
         * Convert string, that represents localized number, into number if possible
         * At the moment this method is a terrible hack because it is made to be called on every form input regardless
         * of type. As a result we must guess if it is really a number simply by parsing value. Thus, at any point when
         * we suspect that value is not a plain number - we reject parsing and return initial value.
         * @param {String} str - source string
         * @param {Object} [options] - source format params
         * @param {String} [options.thSeparator] - thousand separator
         * @param {String} [options.decSeparator] - decimal separator
         * @return {*|Number|String}
         */
        delocalizeNumber: function(str, options) {
            if (typeof str !== 'string') {
                return str;
            }

            options = _.defaults(options || {}, formatter.numberOptions);

            var thSeparatorRegex = new RegExp('\\' + options.thSeparator, 'g');
            var decSeparatorRegex = new RegExp('\\' + options.decSeparator, 'g');
            var numberStr = str.replace(thSeparatorRegex, '').replace(decSeparatorRegex, '.');
            var result = parseFloat(numberStr);

            if (isNaN(result) || String(result) !== numberStr) {
                return str;
            }

            return result;
        },

        /**
         * Formats number according to options
         * @param {Number|String} number - number to format
         * @param {Object} [options] - format params
         * @param {Number} [options.precision] - decimal precision
         * @param {String} [options.thSeparator] - thousand separator
         * @param {String} [options.decSeparator] - decimal separator
         * @return {String}
         */
        formatNumber: function(number, options) {
            options = options || {};
            _.defaults(options, formatter.numberOptions);

            number = parseFloat(number);

            if (isNaN(number)) {
                return '';
            }

            var formattedNumber;

            if (options.precision != null) {
                formattedNumber = number.toFixed(options.precision);
            } else {
                formattedNumber = number.toString();
            }

            var numberParts = formattedNumber.split('.');
            var thGroupsRe = /(\d)(?=(\d{3})+\b)/g;
            numberParts[0] = numberParts[0].replace(thGroupsRe, '$1' + options.thSeparator);

            if (!numberParts[1]) {
                formattedNumber = numberParts[0];
            } else {
                formattedNumber = numberParts.join(options.decSeparator);
            }

            return formattedNumber;
        },

        /**
         * Formats amount in currency according to options
         * @param {Number|String} amount - amount to format
         * @param {Object} [options] - format params
         * @param {String} [options.currencyCode] - currency
         * @param {String} [options.symbolAtTheLeft] - 'true' to draw currency symbol to the left of amount
         * @param {Number} [options.precision] - decimal precision
         * @param {String} [options.thSeparator] - thousand separator
         * @param {String} [options.decSeparator] - decimal separator
         */
        formatCurrency: function(amount, options) {
            options = options || {};
            _.defaults(options, formatter.currencyOptions);

            var formattedAmount = formatter.formatNumber(amount, options);
            var currencySymbol = formatter.getCurrencySymbol(options.currencyCode);

            if (options.symbolAtTheLeft) {
                formattedAmount = currencySymbol + ' ' + formattedAmount;
            } else {
                formattedAmount = formattedAmount + ' ' + currencySymbol;
            }

            return formattedAmount.trim();
        },

        /**
         * Gets currency symbol to display
         * @param {String} [currencyCode] - Currency code
         * @returns {*|string}
         */
        getCurrencySymbol: function(currencyCode) {
            currencyCode = currencyCode || formatter.currencyOptions.currencyCode || '';

            return formatter.currencies[currencyCode] || currencyCode || '';
        },

        /**
         * @private
         * @param  {String} target - locale
         * @param  {String} source - name of list with locales
         * @return {{number: *, currency: *}}
         */
        _getOptions: function(target, source) {
            var predefinedOptions = formatter[source][target];

            if (!predefinedOptions) {
                return {
                    number: _.clone(_numberDefaults),
                    currency: _.clone(_currencyDefaults)
                };
            }

            return {
                number: _.defaults({}, predefinedOptions.number, _numberDefaults),
                currency: _.defaults({}, predefinedOptions.currency, _currencyDefaults)
            };
        },

        getOptions: function(locale) {
            var regulation = Playtech.Variables.regulation;
            var source = 'locales';

            if (regulation) {
                locale = regulation;
                source = 'regulations';
            }

            return formatter._getOptions(locale, source);
        },

        /**
         * @deprecated Use getOptions() instead
         * Gets options for locale
         * @param {String} [locale] - Returns defaults if empty
         * @returns {{number: *, currency: *}}
         */
        getOptionsFromLocale: function(locale) {
            return formatter._getOptions(locale, 'locales');
        },

        /**
         * Sets current formatting options
         * @param {Object} [options] - options to set; Sets default if empty
         * @param {Boolean} [clone] - whether clone 'options' or set as is
         * * Most of the time you don't need to clone options
         *   because related method getOptionsFromLocale() always returns a clone.
         * * setOptions() method does not extend defaults, but sets provided object as options "as is".
         */
        setOptions: function(options, clone) {
            if (!options) {
                options = formatter.getOptions();
            }

            formatter.numberOptions = clone ? _.clone(options.number) : options.number;
            formatter.currencyOptions = clone ? _.clone(options.currency) : options.currency;
        },

        /**
         * Format contact preferences for subscriptions
         * @param {Object} subscriptions List of configured channels
         * @return {Array}
         */
        formatContactPreferences: function(subscriptions) {
            var supportedNames = ['email', 'phone', 'directMail', 'SMS', 'mobilePush', 'internalMessage', 'desktopCompanion'];
            var allChannels = _.filter(subscriptions, function(subscription) {
                return subscription.channel === 'all';
            });
            var contactPreferences = [];
            var findOverriddenPref = function(allPrefsArr, customPrefs) {
                return _.find(allPrefsArr, function(allPrefs) {
                    return allPrefs.channel === customPrefs.channel &&
                        allPrefs.type === customPrefs.type;
                });
            };

            if (allChannels.length) {
                _.each(allChannels, function(allChannel) {
                    _.each(supportedNames, function(name) {
                        contactPreferences.push({
                            channel: name,
                            type: allChannel.type,
                            preference: allChannel.preference
                        });
                    });
                });
            }

            for (var key in subscriptions) {
                var sub = subscriptions[key];

                if (sub.channel !== 'all') {
                    // override prefs in all by custom pref
                    var overridePrefs = findOverriddenPref(contactPreferences, sub);

                    if (overridePrefs) {
                        overridePrefs.preference = sub.preference;
                    } else {
                        // eslint-disable-next-line no-loop-func
                        sub.type.split(',').forEach(function(value) {
                            contactPreferences.push(_.extend({}, sub, { type: value.trim() }));
                        });
                    }
                }
            }

            return contactPreferences;
        }
    };

    module.exports = formatter;
});
